import { downloadFollowUp } from 'services/results/follow-up'
import { StrokedButton } from 'views/components/UI/Buttons'
import { ComparisonLayout } from './comparison-styled'

const show = (value: any) => (value === null || value === undefined ? 'No disponible' : String(value))
const date = (value: string | null) => (value ? value.slice(0, 10).split('-').reverse().join('/') : 'No disponible')
const delta = (value: any) =>
  value === null || value === undefined ? 'No disponible' : `${Number(value) > 0 ? '+' : ''}${value}`
const tableHead = (
  <thead>
    <tr>
      <th scope="col">Indicador</th>
      <th scope="col">Original</th>
      <th scope="col">Follow Up</th>
      <th scope="col">Cambio</th>
    </tr>
  </thead>
)

export default function SkillsComparisonContent({
  comparison,
  processId,
  busy,
  action,
}: {
  comparison: any
  processId: number
  busy: boolean
  action: (work: () => Promise<unknown>) => Promise<void>
}) {
  return (
    <ComparisonLayout>
      <h4>
        Inicial #{comparison.initial.id} frente a Follow Up #{comparison.follow_up.id}
      </h4>
      <div className="downloads">
        <StrokedButton
          disabled={busy}
          onClick={() =>
            action(() =>
              downloadFollowUp(
                processId,
                `comparison/${comparison.follow_up.id}/pdf`,
                `Comparativo_3DSkills_${comparison.initial.id}_${comparison.follow_up.id}.pdf`
              )
            )
          }
        >
          PDF comparativo
        </StrokedButton>
        <StrokedButton
          disabled={busy}
          onClick={() =>
            action(() =>
              downloadFollowUp(
                processId,
                'excel',
                `Comparativo_3DSkills_${comparison.initial.id}_${comparison.follow_up.id}.xlsx`,
                { category_id: 2, user_test_id: comparison.follow_up.id }
              )
            )
          }
        >
          Excel comparativo
        </StrokedButton>
      </div>
      <div className="measurements">
        <div className="measurement">
          <strong>Medición original #{comparison.initial.id}</strong>
          <span>{date(comparison.initial.answer_date)}</span>
        </div>
        <div className="measurement current">
          <strong>Follow Up #{comparison.follow_up.id}</strong>
          <span>{date(comparison.follow_up.answer_date)}</span>
        </div>
      </div>
      <aside className="methodology" aria-label="Nota metodológica">
        <strong>Ten en cuenta al interpretar</strong>
        <p>{comparison.methodological_note}</p>
        <p>{comparison.interpretation}</p>
      </aside>
      <p className="guide">
        Puntuaciones de competencias y objetivos: 0–100. Brecha = objetivo − puntuación. Un cambio de brecha negativo
        representa reducción. Dimensiones: puntuaciones normalizadas de 0 a 100 por competencia. Ajuste: porcentaje; su
        cambio se expresa en puntos porcentuales.
      </p>
      {comparison.rows.map((r: any) => (
        <section className="skill" key={r.skill_id} aria-label={r.skill_name}>
          <h5>{r.skill_name}</h5>
          <div className="section">
            <h6>Resultados observados · 0–100</h6>
            <div className="table-scroll">
              <table aria-label={`Resultados de ${r.skill_name}`}>
                {tableHead}
                <tbody>
                  <tr className="total">
                    <th scope="row">Puntuación de competencia</th>
                    <td>{show(r.before)}</td>
                    <td>{show(r.after)}</td>
                    <td>
                      <span className="delta">{delta(r.change)}</span>
                    </td>
                  </tr>
                  {r.dimensions.map((d: any) => (
                    <tr className="dimension" key={d.name}>
                      <th scope="row">{d.name}</th>
                      <td>{show(d.before)}</td>
                      <td>{show(d.after)}</td>
                      <td>{delta(d.change)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="section">
            <h6>Referencia del perfil ideal</h6>
            <div className="table-scroll">
              <table aria-label={`Perfil y brechas de ${r.skill_name}`}>
                {tableHead}
                <tbody>
                  <tr>
                    <th scope="row">Objetivo del perfil (0–100)</th>
                    <td>{show(r.before_ideal)}</td>
                    <td>{show(r.after_ideal)}</td>
                    <td>
                      {delta(r.before_ideal == null || r.after_ideal == null ? null : r.after_ideal - r.before_ideal)}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Brecha (puntos)</th>
                    <td>{show(r.before_gap)}</td>
                    <td>{show(r.after_gap)}</td>
                    <td>
                      <span className="delta">{delta(r.gap_change)}</span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Ajuste (%) · cambio en pp</th>
                    <td>{show(r.before_adjustment)}</td>
                    <td>{show(r.after_adjustment)}</td>
                    <td>{delta(r.adjustment_change_pp)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      ))}
    </ComparisonLayout>
  )
}
